
export enum ButtonDisplayStyle {
    Primary = 'Primary',
    Secondary = 'Default',
    Tertiary = 'Tertiary',
}

export enum ButtonAccent {
    Neutral = 'Neutral',
    Accent = 'Accent',
    Danger = 'Danger',
}

export enum ButtonMode {
    Button = 'Button',
    Dropdown = 'Dropdown',
    Select = 'Select',
    Menu = 'Menu',
    Split = 'Split',
    Toggle = 'Toggle',
    Tab = 'Tab',
    Overlay = 'Overlay',
    MenuItem = 'MenuItem',
    Icon = 'Icon',
    Link = 'Link',
}

export enum ButtonSize {
    Small = 'Small',
    Medium = 'Medium',
    Large = 'Large'
}

export enum ButtonIconSize {
    Default = 'Default',
    Small = 'Small',
    Medium = 'Medium',
    Large = 'Large'
}

export enum ButtonMenuAlign {
    Left = 'Left',
    Right = 'Right'
}